import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

export class Encrypt {
    public static async getE2EEpd(input:string): Promise<string> {
        let e2eePd = '';
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;
        await Network.sendAPI(
            "/api/e2ee/GetTimeAndKey",
            "get"
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
                const e2eeResponse = TCBReceiptApi.Protobuf.E2eeResponse.decode(
                    new Uint8Array(response.item)
                );
                console.log(e2eeResponse);
                e2eePd = this.CertEncryptTimeStamp(e2eeResponse.pubKey, input, e2eeResponse.serverTime, '0');
            })
            .catch(error => {
                Log.error(error);
            });
            return e2eePd;
    }

    private static CertEncryptTimeStamp(publicKey:string, input:string, sRSATime:string, iflags:string) {
        const rsatimePattern = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})Z$/;
        if (typeof(sRSATime) === 'string') {
            if (!rsatimePattern.test(sRSATime))
                throw "Invalid timestamp format"; 
        } else {
            iflags = sRSATime;
            const date = new Date();
            if (date.toISOString) {
                // IE9 and above
                const isostrPattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})Z$/;
                sRSATime = date.toISOString().replace(isostrPattern, "$1-$2-$3 $4:$5:$6Z"); // format: "YYYY-MM-DD HH:mm:ssZ"
            } else {
                sRSATime = date.getUTCFullYear().toString();
                sRSATime += "-";
                sRSATime += ("0" + (date.getUTCMonth() + 1)).slice(-2);
                sRSATime += "-";
                sRSATime += ("0" + date.getUTCDate()).slice(-2);
                sRSATime += " ";
                sRSATime += ("0" + date.getUTCHours()).slice(-2);
                sRSATime += ":";
                sRSATime += ("0" + date.getUTCMinutes()).slice(-2);
                sRSATime += ":";
                sRSATime += ("0" + date.getUTCSeconds()).slice(-2);
                sRSATime += "Z";
            }
        }
        return (window as any).CGJSCrypt.CertEncrypt(publicKey, input + sRSATime, iflags);
    }
}

